<template>
    <div class="bg-white p-1 mb-8">
        <button @click="toggleFilters" class="w-full flex justify-between content-center p-1 focus:outline-none" title="Vis eller skjul filtervalgene">
            <div>
                {{ title }}
            </div>
            <div class="px-1 py-1 border border-gray-300 bg-gray-100 cursor-pointer hover:bg-white hover:border-gray-500 leading-none text-sm">
                <font-awesome-icon icon="chevron-down" v-if="!toggleFilter"/>
                <font-awesome-icon icon="chevron-up" v-if="toggleFilter"/>
            </div>
        </button>
        <ul v-show="toggleFilter" class="text-sm border-t">
            <slot></slot>
            <li>
                <button class="bg-green-200 py-1 px-2 w-full hover:bg-blue-200" @click="clearFilter">
                    Nullstill filter
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        showFilter: {
            type: Number,
            'default': 0
        }
    },
    data() {
        return {
            toggleFilter: this.showFilter
        };
    },
    methods: {
        toggleFilters() {
            if (this.toggleFilter === 1) {
                this.toggleFilter = 0;
            } else {
                this.toggleFilter = 1;
            }
        },
        clearFilter() {
            this.$emit('clearFilter', this.type);
        }
    }
};
</script>
